import classNames from "classnames";
import styles from "./AscMediaFileCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { FileIcon, CircleCloseIcon } from "../../AscIcons";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscProgressBar from "../../AscProgressBar/AscProgressBar";
dayjs.extend(relativeTime);

export interface AscFiltersCardProps {
  className?: string;
  loading?: boolean;
  fileName: string;
  fileSize: string;
  progress?: number;
  completed?: boolean;
}

export default function AscMediaFileCard({
  className,
  loading,
  fileName,
  fileSize,
  progress,
  completed,
}: AscFiltersCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
      loading={loading}
    >
      <FileIcon className={styles.fileIcon} />
      <div className={styles.details}>
        <AscParagraph className={styles.fileName}>{fileName}</AscParagraph>
        {progress && !completed ? (
          <AscProgressBar fullWidth value={progress} />
        ) : (
          <AscParagraph className={styles.fileSize}>{fileSize}</AscParagraph>
        )}
      </div>
      <CircleCloseIcon className={styles.closeIcon} />
    </AscGenericCard>
  );
}
